import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import './index.css';
import { Spinner } from 'react-bootstrap';

const Employee = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    phone: '',
  });

  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    const { name, email, password, phone } = formData;

    if (!name || !email || !password || !phone) {
      setError('All fields are required');
      setLoading(false);
      return;
    }

    const newEmployee = { name, email, password, phone };

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/employee', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newEmployee),
      });

      if (response.ok) {
        setSuccess('Employee added successfully');
        setFormData({
          name: '',
          email: '',
          password: '',
          phone: '',
        });
        setError('');
        // Clear success message after 3 seconds
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError('Failed to add employee. Please try again.');
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      <div className="container mt-5">
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h2 className="mb-0">Add Employee</h2>
            <button className="btn btn-primary" onClick={() => navigate('/Employeelist')}>
              Employee List
            </button>
          </div>

          <div className="card-body">
            {loading ? (
              <div className="text-center my-5">
                <Spinner animation="border" role="status" />
                <div className="mt-3">Submitting Employee...</div>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Enter Employee Name"
                      required
                      autoFocus
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter Employee Email"
                      required
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" className="form-control" id="password" name="password" value={formData.password} onChange={handleInputChange} placeholder="Enter Password" required/>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label htmlFor="phone" className="form-label">Phone</label>
                    <input type="tel" className="form-control" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Enter Phone Number" required/>
                  </div>
                </div>



                <div className="text-center">
                  <button type="submit" className="btn btn-primary" disabled={loading}>
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Employee;
